angular
    .module('festzelt-os.modules.tickets.templates', [
        'ui.router',
        'festzelt-os.components'
    ]);

require('./routes');

// Components
require('./components/al-ticket-template-preview/component');
require('./components/al-ticket-template-editor/component');
require('./components/al-ticket-template-map-setting/component');

// Factories
require('./factories/template');

// Stores
require('./store/templates');

// Workflows
require('./workflows/list/create-ticket-template');

require('./workflows/details/archive-ticket-template');
require('./workflows/details/delete-ticket-template');
require('./workflows/details/duplicate');
require('./workflows/details/restore-ticket-template');



// WEBPACK FOOTER //
// ./src/app/modules/tickets/templates/module.js